import CheckIcon from "@mui/icons-material/Check";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { colors } from "@/theme/colors";

type Props = {
  title: string;
  message: string;
};

/**
 * アンケートのお礼表示。回答直後と、回答済みトークンで再訪した場合の双方で使う (§6.7)。
 *
 * 見た目は ErrorStateView に合わせ、円形アイコン + 見出し + 説明文を縦に積む。severity は持たず
 * ゴールドの Check で固定する (ErrorStateView の info は Close アイコンで「できません」の表示に
 * 割り当てられており、お礼には使えない)。
 */
export function NPSThanksView({ title, message }: Props) {
  return (
    <Box
      role="status"
      sx={{
        p: { xs: 2, sm: 3, md: 4 },
        maxWidth: 640,
        width: "100%",
        mx: "auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: "50%",
          bgcolor: colors.gold,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mt: 4,
          mb: 2,
        }}
      >
        <CheckIcon sx={{ color: "#fff", fontSize: 24 }} />
      </Box>

      <Typography variant="h6" sx={{ fontWeight: 700, color: colors.text, mb: 1.5 }}>
        {title}
      </Typography>

      <Typography sx={{ color: colors.textBody, fontSize: 16, whiteSpace: "pre-line", mb: 4 }}>
        {message}
      </Typography>
    </Box>
  );
}
